import React from 'react';
import { useSelector } from 'react-redux';
import { Container, Col, Row } from '@yme/atoms/grid';
import { IndentWrapper } from '@yme/components/Separator';
import { getRTL } from '@yme/selectors/common';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { RegularTextLevel4 } from '@yme/tokens/typography';
import { COPYRIGHT_DATA_TEST_ID } from './constants';
import { CopyrightInfoStyled } from './styled';
export function CopyrightInfo(props) {
    const { copyright, description, isRemoveBottomIndent } = props;
    const isRightToLeft = useSelector(getRTL);
    if (!copyright) {
        return null;
    }
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(Container, { dataTestId: COPYRIGHT_DATA_TEST_ID, isRightToLeft: isRightToLeft },
            React.createElement(Row, { justifyContent: "center" },
                React.createElement(Col, { lg: 6 },
                    React.createElement(CopyrightInfoStyled, null,
                        React.createElement(RegularTextLevel4, { color: colorCoreBlack300 }, copyright),
                        description && (React.createElement(RegularTextLevel4, { color: colorCoreBlack300 }, description))))))));
}
CopyrightInfo.displayName = 'CopyrightInfo_AEMComponent';
